module.exports = __webpack_public_path__ + "static/media/image_2.9325a75a.png";